import { TornadoIcon } from "./weather-icons/TornadoIcon.component";
import { TropicalStormIcon } from "./weather-icons/TropicalStormIcon.component";
import { HurricaneIcon } from "./weather-icons/HurricaneIcon.component";
import { StrongStormsIcon } from "./weather-icons/StrongStormsIcon.component";
import { ThunderstormsIcon } from "./weather-icons/ThunderstormsIcon.component";
import { RainSnowIcon } from "./weather-icons/RainSnowIcon.component";
import { RainSleetIcon } from "./weather-icons/RainSleetIcon.component";
import { WintryMixIcon } from "./weather-icons/WintryMixIcon.component";
import { FreezingDrizzleIcon } from "./weather-icons/FreezingDrizzleIcon.component";
import { DrizzleIcon } from "./weather-icons/DrizzleIcon.component";
import { FreezingRainIcon } from "./weather-icons/FreezingRainIcon.component";
import { ShowersIcon } from "./weather-icons/ShowersIcon.component";
import { RainIcon } from "./weather-icons/RainIcon.component";
import { FlurriesIcon } from "./weather-icons/FlurriesIcon.component";
import { SnowShowersIcon } from "./weather-icons/SnowShowersIcon.component";
import { BlowingSnowIcon } from "./weather-icons/BlowingSnowIcon.component";
import { SnowIcon } from "./weather-icons/SnowIcon.component";
import { HailIcon } from "./weather-icons/HailIcon.component";
import { SleetIcon } from "./weather-icons/SleetIcon.component";
import { SandstormIcon } from "./weather-icons/SandstormIcon.component";
import { FoggyIcon } from "./weather-icons/FoggyIcon.component";
import { HazeIcon } from "./weather-icons/HazeIcon.component";
import { SmokeIcon } from "./weather-icons/SmokeIcon.component";
import { BreezyIcon } from "./weather-icons/BreezyIcon.component";
import { WindyIcon } from "./weather-icons/WindyIcon.component";
import { FrigidIcon } from "./weather-icons/FrigidIcon.component";
import { CloudyIcon } from "./weather-icons/CloudyIcon.component";
import { MostlyCloudyNightIcon } from "./weather-icons/MostlyCloudyNightIcon.component";
import { MostlyCloudyDayIcon } from "./weather-icons/MostlyCloudyDayIcon.component";
import { PartlyCloudyNightIcon } from "./weather-icons/PartlyCloudyNightIcon.component";
import { PartlyCloudyDayIcon } from "./weather-icons/PartlyCloudyDayIcon.component";
import { ClearIcon } from "./weather-icons/ClearIcon.component";
import { SunnyIcon } from "./weather-icons/SunnyIcon.component";
import { MostlyClearIcon } from "./weather-icons/MostlyClearIcon.component";
import { MostlySunnyIcon } from "./weather-icons/MostlySunnyIcon.component";
import { MixedRainIcon } from "./weather-icons/MixedRainIcon.component";
import { HotIcon } from "./weather-icons/HotIcon.component";
import { IsolatedThunderstormsIcon } from "./weather-icons/IsolatedThunderstormsIcon.component";
import { ScatteredThunderStormsDayIcon } from "./weather-icons/ScatteredThunderStormsDayIcon.component";
import { ScatteredShowersDayIcon } from "./weather-icons/ScatteredShowersDayIcon.component";
import { HeavyRainIcon } from "./weather-icons/HeavyRainIcon.component";
import { ScatteredSnowShowersDayIcon } from "./weather-icons/ScatteredSnowShowersDayIcon.component";
import { HeavySnowIcon } from "./weather-icons/HeavySnowIcon.component";
import { BlizzardIcon } from "./weather-icons/BlizzardIcon.component";
import { NotAvailableIcon } from "./weather-icons/NotAvailableIcon.component";
import { ScatteredShowersNightIcon } from "./weather-icons/ScatteredShowersNightIcon.component";
import { ScatteredSnowShowersNightIcon } from "./weather-icons/ScatteredSnowShowersNightIcon.component";
import { ScatteredThunderStormsNightIcon } from "./weather-icons/ScatteredThunderStormsNightIcon.component";

interface WeatherIconProps {
    iconCode: number;
}

interface WeatherIconRegistry {
    [s: string]: JSX.Element | null;
}

export const weatherIconMap: WeatherIconRegistry = {
    0: <TornadoIcon />,
    1: <TropicalStormIcon />,
    2: <HurricaneIcon />,
    3: <StrongStormsIcon />,
    4: <ThunderstormsIcon />,
    5: <RainSnowIcon />,
    6: <RainSleetIcon />,
    7: <WintryMixIcon />,
    8: <FreezingDrizzleIcon />,
    9: <DrizzleIcon />,
    10: <FreezingRainIcon />,
    11: <ShowersIcon />,
    12: <RainIcon />,
    13: <FlurriesIcon />,
    14: <SnowShowersIcon />,
    15: <BlowingSnowIcon />,
    16: <SnowIcon />,
    17: <HailIcon />,
    18: <SleetIcon />,
    19: <SandstormIcon />,
    20: <FoggyIcon />,
    21: <HazeIcon />,
    22: <SmokeIcon />,
    23: <BreezyIcon />,
    24: <WindyIcon />,
    25: <FrigidIcon />,
    26: <CloudyIcon />,
    27: <MostlyCloudyNightIcon />,
    28: <MostlyCloudyDayIcon />,
    29: <PartlyCloudyNightIcon />,
    30: <PartlyCloudyDayIcon />,
    31: <ClearIcon />,
    32: <SunnyIcon />,
    33: <MostlyClearIcon />,
    34: <MostlySunnyIcon />,
    35: <MixedRainIcon />,
    36: <HotIcon />,
    37: <IsolatedThunderstormsIcon />,
    38: <ScatteredThunderStormsDayIcon />,
    39: <ScatteredShowersDayIcon />,
    40: <HeavyRainIcon />,
    41: <ScatteredSnowShowersDayIcon />,
    42: <HeavySnowIcon />,
    43: <BlizzardIcon />,
    44: <NotAvailableIcon />,
    45: <ScatteredShowersNightIcon />,
    46: <ScatteredSnowShowersNightIcon />,
    47: <ScatteredThunderStormsNightIcon />,
    na: <NotAvailableIcon />,
};

export const WeatherIcon = (props: WeatherIconProps) => {
    // set default to Not Available Icon
    return weatherIconMap[props.iconCode] || weatherIconMap[44];
};
